<div class="form-header">
  <span *ngIf="edited.id && edited.id > 0">Edit</span>
  <span *ngIf="!edited.id || edited.id === -1">Add</span>
  alert
</div>
<form class="form-view" [formGroup]="alertDefinitionForm" (ngSubmit)="onSubmitForm(alertDefinitionForm)">

  <div class="dialog-container">
    <div class="field" required>
      <mat-form-field>
        <mat-label>Alert name</mat-label>
        <input matInput maxlength="50" formControlName="name" name="name">
      </mat-form-field>
    </div>
    <div class="field" required>
      <mat-form-field>
        <mat-label>Alert text</mat-label>
        <input matInput maxlength="50" formControlName="text" name="text">
      </mat-form-field>
    </div>
    <div class="field" required>
      <mat-form-field appearance="fill">
        <mat-label>Icon</mat-label>
        <mat-select formControlName="icon">
          <mat-option *ngFor="let icon of icons" [value]="icon.value">{{icon.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field" required>
      <mat-form-field appearance="fill">
        <mat-label>Teams</mat-label>
        <mat-select formControlName="practitionerGroups" multiple>
          <mat-option *ngFor="let group of groups" [value]="group.id">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field" required>
      <mat-form-field appearance="fill">
        <mat-label>Include</mat-label>
        <mat-select formControlName="inclusions" multiple>
          <mat-option *ngFor="let option of getInclusions()" [value]="option">{{option}}</mat-option>
        </mat-select>
        <mat-hint class="hint">Alerts can be based on the highest overall compass score or on individual trackables with the highest scores based on logging. For Promis assessment a high score is taken into account.</mat-hint>
      </mat-form-field>
    </div> 

    <div class="button-container">
      <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button
        color="primary">Save</button>
      <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
    </div>
  </div>

</form>